import { NgModule } from '@angular/core';

import { ApChatBubbleComponent } from '@ap/chat-bubble';
import { ApContentPipe, ApContentService } from '@ap/content';
import { ApIllustrationComponent } from '@ap/illustration';
import { ApNotificationComponent } from '@ap/notification';

import { ConversationalChatContainerModule } from './conversational-chat-container/conversational-chat-container.module';
import { ConversationalChatDisclaimerModule } from './conversational-chat-disclaimer/conversational-chat-disclaimer.module';
import { ConversationalChatInputModule } from './conversational-chat-input/conversational-chat-input.module';
import { ConversationalChatMessageModule } from './conversational-chat-message/conversational-chat-message.module';
import { ConversationalChatSkeletonComponent } from './conversational-chat-skeleton/conversational-chat-skeleton.component';
import { KlantConversationalComponent } from './klant-conversational.component';

/**
 * @ngdoc module
 * @name KlantConversationalModule
 **/
@NgModule({
    declarations: [KlantConversationalComponent],
    imports: [
        ConversationalChatMessageModule,
        ConversationalChatContainerModule,
        ConversationalChatInputModule,
        ConversationalChatDisclaimerModule,
        ApChatBubbleComponent,
        ApContentPipe,
        ApIllustrationComponent,
        ApNotificationComponent,
        ConversationalChatSkeletonComponent
    ],
    exports: [KlantConversationalComponent],
    providers: [ApContentService]
})
export class KlantConversationalModule {}
